export const galleryCities = [
  
  {
  id: 1,
  slug: 'chefchaouen',
  name: 'Chefchaouen',
  coverImage: '/assets/cities/chefchaouen/chefhero.jpg',
  heroImage: '/assets/cities/chefchaouen/chefhero.jpg',
  description: 'Chefchaouen — Where Blue Becomes Emotion. Some places you see in pictures, and some places you must feel. This magical blue city nestled in the Rif Mountains is one of them. Every alley looks like a painting, every moment feels like a dream. The air is fresh, the pace is calm, and something inside you simply slows down. Wander through breathtaking blue streets, discover authentic local art, and explore unique markets unlike anywhere else in the world. This is not just another destination—it\'s a deep, emotional experience that stays with you long after you leave. If you\'re looking for beauty, peace, and a true connection, Chefchaouen is waiting for you.',
  galleryImages: [
    '/assets/cities/chefchaouen/chef (1).jpg',
    '/assets/cities/chefchaouen/chef (2).jpg',
    '/assets/cities/chefchaouen/chef (3).jpg',
    '/assets/cities/chefchaouen/chef (4).jpg',
    '/assets/cities/chefchaouen/chef (5).jpg',
    '/assets/cities/chefchaouen/chef (6).jpg',
  ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918685/chef_1_xdt8sk.mp4',
        title: 'Chefchaouen Dream'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918678/chef_2_og13gs.mp4',
        title: 'Blue Alleys'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918678/chef_3_ksyxa6.mp4',
        title: 'Hidden Gems'
      }
    ]
},
  {
    id: 2,
    slug: 'fes',
    name: 'Fes',
    coverImage: '/assets/cities/fes/fes.jpg',
    heroImage: '/assets/cities/fes/fes.jpg',
    description: 'Fes is one of Morocco\'s oldest and most enchanting cities, home to the world\'s oldest university and a UNESCO World Heritage Site. The ancient medina (old town) is a labyrinth of narrow streets filled with traditional crafts, spice markets, and leather tanneries. Wander through centuries-old souks, discover hidden riads with intricate tilework, and experience the authentic heartbeat of Morocco in this culturally rich destination.',
    galleryImages: [
      '/assets/cities/fes/fes1.jpg',
      '/assets/cities/fes/fes2.jpg',
      '/assets/cities/fes/fes3.jpg',
      '/assets/cities/fes/fes4.jpg',
      '/assets/cities/fes/fes5.jpg',
      '/assets/cities/fes/fes6.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917661/fes_tb2e8o.mp4',
        title: 'Fes Medina'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917695/WhatsApp_Video_2026-05-04_at_18.58.40_igqupy.mp4',
        title: 'Fes Atmosphere'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917695/WhatsApp_Video_2026-05-04_at_18.58.41_l0vbma.mp4',
        title: 'Fes Streets'
      }
    ]
  },
  {
    id: 3,
    slug: 'casablanca',
    name: 'Casablanca',
    coverImage: '/assets/cities/casa/casa.webp',
    heroImage: '/assets/cities/casa/casa.webp',
    description: "Casablanca — The White City Where Modernity Meets the Atlantic. Casablanca is more than just Morocco's heartbeat; it's a bridge between a glorious past and a soaring future. From the majestic Hassan II Mosque, standing proudly over the ocean waves, to the sleek skyscrapers and the Art Deco charm of its boulevards, the city pulses with a unique cosmopolitan energy. Feel the salty breeze at the Corniche, witness the grandeur of its architecture, and lose yourself in the vibrant rhythm of a metropolis that never sleeps. Casablanca isn't just a destination—it's the soul of modern Morocco, waiting to share its story with you.",
    galleryImages: [
      '/assets/cities/casa/casa.webp',
      '/assets/cities/casa/casa (2).jpg',
      '/assets/cities/casa/casa (3).jpg',
      '/assets/cities/casa/casa (4).jpg',
      '/assets/cities/casa/casa (5).jpg',
      '/assets/cities/casa/casa (6).jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918618/casa_1_jo2y8o.mp4',
        title: 'Hassan II Mosque'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918619/casa_2_phkkjz.mp4',
        title: 'Modern Casablanca'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918618/casa_3_l4i7wz.mp4',
        title: 'Atlantic Breeze'
      }
    ]
  },
  {
    id: 4,
    slug: 'marrakech',
    name: 'Marrakech',
    coverImage: '/assets/cities/marakech/kech.jpg',
    heroImage: '/assets/cities/marakech/kech.jpg',
    description: 'Marrakech, the Red City, is a vibrant destination filled with exotic markets, beautiful gardens, and stunning architecture. The iconic Jemaa el-Fnaa square pulses with snake charmers, musicians, and food stalls, while serene gardens like Menara and Majorelle provide peaceful retreats. Experience the perfect blend of bustling medinas and tranquil palaces in this magical city that has captivated travelers for centuries.',
    galleryImages: [
      '/assets/cities/marakech/kech1.jpg',
      '/assets/cities/marakech/kech2.jpg',
      '/assets/cities/marakech/kech3.jpg',
      '/assets/cities/marakech/kech4.jpg',
      '/assets/cities/marakech/kech5.jpg',
      '/assets/cities/marakech/kech.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918371/WhatsApp_Video_2026-05-04_at_12.44.03_bzqoym.mp4',
        title: 'Marrakech Life'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918370/WhatsApp_Video_2026-05-04_at_12.50.20_kw8j0i.mp4',
        title: 'Vibrant Souks'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918370/WhatsApp_Video_2026-05-04_at_12.49.47_j0yixj.mp4',
        title: 'Marrakech Magic'
      }
    ]
  },
  {
    id: 5,
    slug: 'merzouga-sahara',
    name: 'Merzouga & Sahara',
    coverImage: '/assets/cities/sahara/sahara1.jpg',
    heroImage: '/assets/cities/sahara/sahara1.jpg',
    description: 'Merzouga & Sahara – Where the Desert Becomes an Experience. Discover the magic of Merzouga and the Sahara Desert — one of the most breathtaking journeys in Morocco. Ride camels across golden dunes, witness unforgettable sunrises and sunsets, and sleep beneath a sky filled with millions of stars. From luxury desert camps and traditional music around the fire to thrilling quad biking and 4x4 adventures, the Sahara offers a rare experience of beauty, silence, and deep emotion. A place where silence speaks, the stars shine brighter, and every moment feels timeless.',
    galleryImages: [
      '/assets/cities/sahara/sahara1.jpg',
      '/assets/cities/sahara/sahara2.jpg',
      '/assets/cities/sahara/sahara3.jpg',
      '/assets/cities/sahara/sahara4.jpg',
      '/assets/cities/sahara/sahara.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917940/WhatsApp_Video_2026-05-04_at_16.33.12_xdelhr.mp4',
        title: 'Sahara Sunset'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917939/WhatsApp_Video_2026-05-04_at_16.34.28_obkivr.mp4',
        title: 'Desert Dunes'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777917938/WhatsApp_Video_2026-05-04_at_16.26.17_knpyvm.mp4',
        title: 'Sahara Experience'
      }
    ]
  },
  {
    id: 6,
    slug: 'ourika-valley',
    name: 'Ourika Valley',
    coverImage: '/assets/cities/ourika/ourika3.jpg',
    heroImage: '/assets/cities/ourika/ourika3.jpg',
    description: 'Ourika Valley, nestled in the High Atlas Mountains just outside Marrakech, is a hidden gem of natural beauty and Berber culture. Crystal-clear rivers, cascading waterfalls, and lush green valleys create a stunning backdrop for hiking and village exploration. Visit traditional Berber villages, enjoy authentic home-cooked cuisine, and discover the warm hospitality of mountain communities in this peaceful alpine retreat.',
    galleryImages: [
      '/assets/cities/ourika/ourika1.jpg',
      '/assets/cities/ourika/ourika2.jpg',
      '/assets/cities/ourika/ourika3.jpg',
      '/assets/cities/ourika/ourika4.jpg',
      '/assets/cities/ourika/ourika.jpg',
      '/assets/cities/ourika/ourikahero.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918539/WhatsApp_Video_2026-05-04_at_13.40.34_y8debg.mp4',
        title: 'Ourika River'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918539/WhatsApp_Video_2026-05-04_at_14.12.03_nmsl0a.mp4',
        title: 'Atlas Landscapes'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918540/WhatsApp_Video_2026-05-04_at_14.12.04_yb28mv.mp4',
        title: 'Berber Heritage'
      }
    ]
  },
  {
    id: 7,
    slug: 'ifran',
    name: 'Ifran',
    coverImage: '/assets/cities/Ifran/ifran1.jpg',
    heroImage: '/assets/cities/Ifran/ifran1.jpg',
    description: 'Known as the "Little Switzerland" of Morocco, Ifran is a unique mountain town nestled in the Middle Atlas. Unlike any other city in the country, it features alpine-style architecture, red-tiled roofs, and lush parks that transform into a winter wonderland during the snow season. Home to the prestigious Al Akhawayn University, Ifran offers a refreshing escape with its crisp mountain air, clean streets, and the famous stone lion statue. It\'s the perfect destination for nature lovers, skiers, and those seeking tranquility in a European-style setting in the heart of Africa.',
    galleryImages: [
      '/assets/cities/Ifran/ifran (1).jpg',
      '/assets/cities/Ifran/ifran (2).jpg',
      '/assets/cities/Ifran/ifran (3).jpg',
      '/assets/cities/Ifran/ifran (5).jpg',
      '/assets/cities/Ifran/ifran1.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777919127/WhatsApp_Video_2026-05-03_at_20.46.27_xjaeb6.mp4',
        title: 'Ifran Winter'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777919128/WhatsApp_Video_2026-05-03_at_20.37.18_f1atxr.mp4',
        title: 'Middle Atlas Beauty'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777919129/WhatsApp_Video_2026-05-03_at_20.46.46_ujfo2z.mp4',
        title: 'Little Switzerland'
      }
    ]
  },
  {
    id: 8,
    slug: 'rabat',
    name: 'Rabat',
    coverImage: '/assets/cities/rabat/rabat.jpg',
    heroImage: '/assets/cities/rabat/rabat.jpg',
    description: 'Rabat, the elegant capital of Morocco, is a city where ancient history and modern life coexist in perfect harmony. As one of the four imperial cities, it boasts magnificent landmarks like the iconic Hassan Tower and the solemn Mausoleum of Mohammed V. Wander through the blue and white streets of the Oudaya Kasbah, enjoy the tranquil beauty of the Chellah necropolis, and experience the refined atmosphere of a city that serves as the nation\'s political and administrative heart. With its Atlantic breeze, manicured gardens, and wide boulevards, Rabat offers a sophisticated and peaceful glimpse into Morocco\'s royal heritage.',
    galleryImages: [
      '/assets/cities/rabat/rabat1.jpg',
      '/assets/cities/rabat/rabat3.jpg',
      '/assets/cities/rabat/rabat4.jpg',
      '/assets/cities/rabat/rabat5.jpg',
      '/assets/cities/rabat/rabat6.jpg',
      '/assets/cities/rabat/rabat.jpg',
    ]
  },
  {
    id: 9,
    slug: 'tangier',
    name: 'Tangier',
    coverImage: '/assets/cities/tanger/tanger.jpg',
    heroImage: '/assets/cities/tanger/tanger.jpg',
    description: 'Tangier, the gateway to Africa, is a legendary city where the Mediterranean meets the Atlantic. Throughout history, it has been a sanctuary for artists, writers, and explorers, creating a unique cosmopolitan atmosphere that sets it apart from any other Moroccan destination. From the mysterious Caves of Hercules and the iconic Cape Spartel to the winding alleys of the Kasbah and the bustling cafes of the Petit Socco, Tangier is a city of myths and modern energy. Experience the salt-tinged breeze, the panoramic views across the Strait of Gibraltar, and the vibrant cultural tapestry of this "Bride of the North."',
    galleryImages: [
      '/assets/cities/tanger/tanger1.jpg',
      '/assets/cities/tanger/tanger2.jpg',
      '/assets/cities/tanger/tanger3.jpg',
      '/assets/cities/tanger/tanger4.jpg',
      '/assets/cities/tanger/tanger5.jpg',
    ],
    galleryVideos: [
      {
        id: 1,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918936/WhatsApp_Video_2026-05-03_at_21.07.42_bzr9lo.mp4',
        title: 'Tangier Bay'
      },
      {
        id: 2,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918937/WhatsApp_Video_2026-05-03_at_21.12.59_gnz9sf.mp4',
        title: 'Gateway to Africa'
      },
      {
        id: 3,
        src: 'https://res.cloudinary.com/dylxqjhjj/video/upload/v1777918935/WhatsApp_Video_2026-05-03_at_21.08.09_aag5xl.mp4',
        title: 'Mediterranean Views'
      }
    ]
  },
  {
    id: 10,
    slug: 'essaouira',
    name: 'Essaouira',
    coverImage: '/assets/cities/essaouira/swira.jpg',
    heroImage: '/assets/cities/essaouira/swira.jpg',
    description: 'Discover Essaouira — Morocco’s most charming coastal city. A historic port where the Atlantic Ocean, ancient medina walls, fresh seafood, and vibrant music come together. From blue fishing boats and ocean breeze to Gnawa rhythms and cultural festivals, Essaouira offers a unique blend of relaxation, authenticity, and artistic soul.',
    galleryImages: [
      '/assets/cities/essaouira/swira1.jpg',
      '/assets/cities/essaouira/swira2.jpg',
      '/assets/cities/essaouira/swira3.jpg',
      '/assets/cities/essaouira/swira4.jpg',
      '/assets/cities/essaouira/swira5.jpg',
      '/assets/cities/essaouira/swira.jpg',
    ]
  }
];